import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { BottomNavigation } from '@/widgets/bottom-navigation';
import { Spinner } from '@/shared/ui/Spinner';

const CatalogPage = lazy(() =>
  import('@/pages/catalog').then((m) => ({ default: m.CatalogPage })),
);
const ProductPage = lazy(() =>
  import('@/pages/product').then((m) => ({ default: m.ProductPage })),
);
const FavoritesPage = lazy(() =>
  import('@/pages/favorites').then((m) => ({ default: m.FavoritesPage })),
);
const CartPage = lazy(() =>
  import('@/pages/cart').then((m) => ({ default: m.CartPage })),
);
const CheckoutPage = lazy(() =>
  import('@/pages/checkout').then((m) => ({ default: m.CheckoutPage })),
);
const OrderDetailPage = lazy(() =>
  import('@/pages/order-detail').then((m) => ({ default: m.OrderDetailPage })),
);
const ProfilePage = lazy(() =>
  import('@/pages/profile').then((m) => ({ default: m.ProfilePage })),
);

function PageFallback(): React.JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100dvh',
      }}
    >
      <Spinner size="lg" />
    </div>
  );
}

export function AppRouter(): React.JSX.Element {
  return (
    <>
      <Suspense fallback={<PageFallback />}>
        <Routes>
          {/* ── Main tabs ─────────────────────────────────────────────── */}
          <Route path="/" element={<Navigate to="/catalog" replace />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="/catalog/:productId" element={<ProductPage />} />
          <Route path="/favorites" element={<FavoritesPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/orders/:orderId" element={<OrderDetailPage />} />

          {/* ── Fallback ──────────────────────────────────────────────── */}
          <Route path="*" element={<Navigate to="/catalog" replace />} />
        </Routes>
      </Suspense>

      {/* Bottom navigation is always visible (except on checkout) */}
      <BottomNavigation />
    </>
  );
}
